module.exports = __webpack_public_path__ + "media/א.12a344a6.mp3";